import React, { Component } from "react"
import PropTypes from 'prop-types'
import { connect } from "react-redux"
//import { withTranslation } from "react-i18next"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import {
  Row,
  Col,
  FormGroup,
  Label
} from "reactstrap"
import classnames from "classnames"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { withTranslation } from "react-i18next";
import SaveButton from "components/buttons/save";
import SafeField from "helpers/SafeField";
class SmsLog extends Component {
  constructor(props) {
    super(props)
    this.state = {


    }

  }
  render() {

    return (
      <React.Fragment>

        <Formik
          enableReinitialize={true}
          initialValues={{
            logDate: new Date(),
            actionType: "SMS Sent",
           



          }}
          validationSchema={Yup.object().shape({
            actionType: Yup.string().required(
              "Please Select Action"
            ),
            smsNote: Yup.string().max(140, 'This filed contains only 140 characters only')
          })}

          onSubmit={this.handleLeadEmailSubmit}
        >
          {({ errors, touched, values, handleChange, setFieldValue }) => (
            <Form
              className="needs-validation"
            >

              <Row className="mb20">



                <Col md="12">
                                                                                            <FormGroup className="mb-3">
                                                                                              <Label htmlFor="builderName">
                                                                                                {this.props.t("Select Type")}
                                                                                              </Label>
                                                                                              <div className="clearfix"></div>
                                                                                              <div className="btn-group" role="group">
                                                                                                <SafeField type="radio" className="btn-check"
                                                                                                  name="actionType" id="actionType_s_1"
                                                                                                  value='SMS Sent'
                                                                                                  checked={values.actionType === 'SMS Sent'}
                                                                                                  onChange={() => {
                                                                                                    setFieldValue("actionType", 'SMS Sent')
                                                                                                    
                                                                                                  }}
                                                                                                  autoComplete="off" />
                                                                                                <label className="btn btn-outline-secondary" htmlFor="actionType_s_1">SMS Sent</label>
                                                    
                                                                                                <SafeField type="radio" className="btn-check"   name="actionType" id="actionType_s_2" value='SMS Received'
                                                                                                  checked={values.actionType === 'SMS Received'}
                                                    
                                                                                                  onChange={() => {
                                                                                                    setFieldValue("actionType", 'SMS Received')
                                                                                    
                                                                                                  }}
                                                    
                                                                                                  autoComplete="off" />
                                                                                                <label className="btn btn-outline-secondary" htmlFor="actionType_s_2">SMS Received</label>
                                                    
                                                                                                <SafeField type="radio" className="btn-check" name="actionType" id="actionType_s_3"
                                                                                                  value={4}
                                                                                                  checked={values.actionType === 'SMS Bounced'}
                                                    
                                                                                                  onChange={() => {
                                                                                                    
                                                                                                    setFieldValue("actionType", "SMS Bounced")
                                                                                                  }}
                                                                                                  autoComplete="off" />
                                                                                                <label className="btn btn-outline-secondary" htmlFor="actionType_s_3">SMS Bounced</label>
                                                    
                                                                                                
                                                                                              </div>
                                                                                              <ErrorMessage
                                                                                                name="activityType"
                                                                                                component="div"
                                                                                                className="invalid-feedback"
                                                                                              />
                                                                                            </FormGroup>
                                                                                        </Col>

              </Row>
              <Row>
                <Col md="12">
                  <FormGroup className="mb-3">
                    <Label htmlFor="logDate">
                      {this.props.t("Log Date")}
                    </Label>
                    <Flatpickr
                      className={
                        "form-control" +
                        (errors.logDate && touched.logDate
                          ? " is-invalid"
                          : "")
                      }
                      placeholder=""
                      value={values.logDate}
                      onChange={(value) => setFieldValue('logDate', value[0])}
                      options={{
                        altInput: true,
                        altFormat: "F j, Y",
                        dateFormat: "Y-m-d"
                      }}
                    />
                    <ErrorMessage
                      name="logDate"
                      component="div"
                      className="invalid-feedback"
                    />

                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <FormGroup className="mb-3">
                    <Label htmlFor="smsNote">
                      {this.props.t("Add Message (Optional)")}
                    </Label>
                    <textarea
                      name="smsNote"
                      onChange={(e) => setFieldValue("smsNote", e.target.value)}
                      type="textarea"
                      value={values.smsNote}

                      className={
                        "form-control" +
                        (errors.smsNote && touched.smsNote
                          ? " is-invalid"
                          : "")
                      }

                      id="smsNote"

                    />
                    <ErrorMessage
                      name="smsNote"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <div className="clearfix"><SaveButton>Save</SaveButton></div>


            </Form>
          )}
        </Formik>
        {/* <div className="h4 card-title mt-20">SMS Log History</div> */}

      </React.Fragment>
    )
  }
}
SmsLog.propTypes = {
  t: PropTypes.any

}
export default connect()(withTranslation()(SmsLog))
